import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { IconSetService } from '@coreui/icons-angular';
import { iconSubset } from './icons/icon-subset';
import { Title } from '@angular/platform-browser';
import { StorageService } from './services/storage.service';
import { isNil } from 'lodash-es';
import { CoreService } from './services/core-service/core-service.service';
declare function gtag(command: string, ...params: any[]): void;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  title = 'Guatemaltecos Ilustres';

  constructor(
    private router: Router,
    private titleService: Title,
    private iconSetService: IconSetService,
    protected storage: StorageService,
    public core: CoreService
  ) {
    titleService.setTitle(this.title);
    // iconSet singleton
    iconSetService.icons = { ...iconSubset };

    if (isNil(this.storage.token)) {
      this.storage.token = { token: '', type: '', logueado: false };
    }

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        gtag('config', 'G-77Q72LDWR5', {
          'page_path': event.urlAfterRedirects
        });
      }
    });
  }

  ngOnInit(): void {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
    });
  }

  get mostrarLock(): boolean {
    return this.core.locked
  }
}
